module.exports = __webpack_public_path__ + "img/noiseOff.2082b841.png";